// API Configuration for different environments
export const API_CONFIG = {
  // Use Railway backend URL in production, localhost in development
  baseURL: import.meta.env.PROD 
    ? import.meta.env.VITE_API_BASE_URL || (globalThis as any).__API_BASE_URL__ || 'https://your-railway-app.railway.app'
    : 'http://localhost:3000',
  
  // API endpoints
  endpoints: {
    auth: {
      login: '/api/auth/login',
      register: '/api/auth/register',
    },
    projects: {
      list: '/api/projects',
      create: '/api/projects',
      get: (id: string) => `/api/projects/${id}`,
      status: (id: string) => `/api/projects/${id}/status`,
      startWorkflow: (id: string) => `/api/projects/${id}/start-workflow`,
    },
    workflow: {
      status: (id: string) => `/api/workflow/${id}/status`,
      reviewData: (id: string, stage: string) => `/api/workflow/${id}/review-data/${stage}`,
    },
    upload: '/api/upload',
  }
};

// Stripe Configuration
export const STRIPE_CONFIG = {
  publishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || 'pk_test_your_publishable_key_here'
};

// Helper function to get full API URL
export function getApiUrl(endpoint: string): string {
  return `${API_CONFIG.baseURL}${endpoint}`;
}

// Helper function to get auth headers
export function getAuthHeaders(): Record<string, string> {
  const token = localStorage.getItem('orca_auth_token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}
